<template>
  <div class="wrap">
    <div class="desktop">
      <div class="app-main">
        <img class="app-icon" src="@/assets/mypc.png" />
        <div class="app-name">我的电脑</div>
      </div>
      <div class="app-main">
        <img class="app-icon" src="@/assets/rubish.png" />
        <div class="app-name">回收站</div>
      </div>
      <div class="app-main" @click="goKpApp()">
        <img class="app-icon" src="@/assets/MainExecute.png" />
        <div class="app-name">开票软件V3.0</div>
      </div>
    </div>
    <vue-draggable-resizable
      :w="dragWidth"
      :h="dragHeight"
      :x="dragX"
      :y="dragY"
      :z="9999"
      :min-width="380"
      :min-height="410"
      :parent="false"
      :grid="[1, 1]"
      @dragging="onDrag"
      @resizing="onResize"
      :active="false"
      :prevent-deactivation="false"
      :disable-user-select="false"
      ref="drag"
      v-show="isShow"
      style="overflow: hidden"
    >
      <div class="login">
        <div class="version">V2.0.42_ZS_202010430</div>
        <div class="taxid">91516850689258158N</div>
        <div class="login_date">{{ date }}</div>
        <select class="user_select">
          <option :value="drawer">{{ drawer }}</option>
        </select>
        <input type="text" class="psw" placeholder="用户密码" v-model="passWord" />
        <input type="text" class="com" placeholder="证书口令" v-model="keyWord" />
        <input type="button" value="登录" class="login_btn" @click="submit()" />
        <input type="button" value="关闭" class="unshow_btn close" @click="closeLogin()" />
        <input type="button" value="缩小" class="unshow_btn shrink" @click="shrinkLogin()" />
      </div>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import { mapGetters, mapActions } from 'vuex'
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util.js'
import ossService from '@/utils/oss.service'
import { environment } from '@/utils/oss.env'
import moment from 'moment'

export default {
  components: {
    VueDraggableResizable,
  },
  data() {
    return {
      dragX: 250,
      dragY: -150,
      dragWidth: 870,
      dragHeight: 540,
      firstRender: true,
      isShow: false,
      drawer: '',
      passWord: '',
      keyWord: '',
      date: moment(new Date()).format('YYYY-MM-DD'),
    }
  },
  computed: {
    ...mapGetters('practice', ['ENTERPRISE', 'LOGIN_INFO', 'TASK_DATA']),
  },
  created() {
    // if (this.TASK_DATA[0].isFinish === '2') {
    //   this.$router.push({
    //     path: '/index',
    //   })
    // }
  },
  methods: {
    shrinkLogin() {
      this.isShow = false
    },
    closeLogin() {
      this.isShow = false
    },
    async goKpApp() {
      const res = await this.taskIsAllFinish()
      if (res) {
        this.msg = this.$message.info('您已完成本次题目！')
      } else {
        this.isShow = true
        this.drawer = this.ENTERPRISE.drawer
      }
    },
    async submit() {
      if ((await this.getTasksBySeq(0)) === null) {
        // 参数错误
        return
      }
      const data = await this.getTasksBySeq(0)

      console.log('data=> :>> ', data)
      if (this.passWord === data.passWord && this.keyWord === data.keyWord) {
        this.updateDetail() // 更新做题信息
        this.$router.push({
          path: '/index',
        })
      } else {
        this.msg = this.$message.error('账号或密码错误')
      }
    },
    async updateDetail() {
      const taskData = await this.getTasksBySeq(0)
      taskData.isFinish = 2
      taskData.status = 0
      const params = parseParam({
        isFinish: taskData.isFinish,
        moduleId: taskData.id,
        status: taskData.status,
      })
      const result = await this.$http.get(`${Urls.updateDetail}&${params}`)
      const submitRes = await this.uploadTestByOSS({ result, isFinish: '2' })
      if (submitRes === 200) {
        // this.uplodeOSS(result, taskData)
        await this.getBusinessList()
        // await this.getQuestionRecord()
      }
    },
    /**
     * 上传做题记录到OSS
     * @param result
     * @param TaskDat
     */
    uplodeOSS(result, taskData) {
      const uu = environment.dshDataUrl + this.LOGIN_INFO.testId + '.o'
      const data = this.TASK_DATA
      const detailId = result.detailId
      const moduleId = result.moduleId
      ossService.ossput(uu, data, moduleId, detailId)
    },
    onResize(x, y, width, height) {
      this.dragX = 0
      this.dragY = 0
      this.dragWidth = width
      this.dragHeight = height
    },
    onDrag(x, y) {
      this.dragX = x
      this.dragY = y
      this.firstRender = false
    },
    ...mapActions('practice', ['taskIsAllFinish', 'getTasksBySeq', 'uploadTestByOSS', 'getBusinessList']),
  },
}
</script>

<style lang="less" scoped>
.wrap {
  min-width: 1080px;
  height: 100vh;
  background: url('~@/assets/timg.a776073ce495b937e4f8.jpg');
}
.desktop {
  overflow: hidden;
  .app-main {
    width: 50px;
    height: 70px;
    flex-shrink: 0;
    margin-top: 20px;
    margin-left: 20px;
    .app-icon {
      display: block;
      width: 100%;
    }
    .app-name {
      text-align: center;
      color: #fff;
      font-size: 12px;
      //   font-size: 0.6rem;
      //   line-height: 1rem;
    }
    &:last-child {
      height: 86px;
    }
  }
}
.login {
  width: 870px;
  height: 540px;
  position: relative;
  background: url('~@/assets/login.png') no-repeat 0 0;
  .version {
    position: absolute;
    top: 58px;
    left: 31px;
    font-size: 15px;
    font-weight: 500;
  }
  .taxid {
    position: absolute;
    top: 481px;
    left: 62px;
    font-size: 13px;
    font-weight: 500;
    color: #0087e5;
  }
  .login_date {
    position: absolute;
    bottom: 14px;
    right: 30px;
    font-size: 13px;
    font-weight: 500;
  }
  .user_select {
    position: absolute;
    width: 262px;
    top: 150px;
    right: 55px;
    height: 27px;
    border: none;
    outline: none;
  }
  .psw {
    position: absolute;
    right: 55px;
    top: 219px;
    width: 262px;
    height: 27px;
    border: none;
    outline: none;
  }
  .com {
    position: absolute;
    right: 55px;
    top: 288px;
    width: 262px;
    height: 27px;
    border: none;
    outline: none;
  }
  .login_btn {
    width: 160px;
    height: 47px;
    border: none;
    background-color: #4fb1ff;
    color: #ffff;
    border-radius: 30px;
    position: absolute;
    top: 398px;
    right: 126px;
    cursor: pointer;
  }
  .unshow_btn {
    position: absolute;
    cursor: pointer;
    opacity: 0;
    width: 27px;
    top: 12px;
    &.close {
      right: 15px;
    }
    &.shrink {
      right: 50px;
    }
  }
}
.handle {
  display: none !important;
}
</style>
